/* eslint-disable import/prefer-default-export */
import { format } from 'date-fns';
import { IDataTableColumn } from '../../../modules/dataTable/DataTable/model';

export const columns: IDataTableColumn<any>[] = [
  {
    name: 'Order Name',
    selector: 'OrderName',
    sortable: true,
    grow: 1,
  },
  {
    name: 'Variety',
    selector: 'Variety',
    sortable: true,
    grow: 0.8,
  },
  {
    name: 'Operator',
    selector: 'OperatorName',
    sortable: true,
    grow: 0.8,
  },
  {
    name: 'Customer',
    selector: 'Customer',
    sortable: true,
    grow: 0.8,
  },
  {
    name: `Start Time (${new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]})`,
    selector: (row: any) => (row.OrderStartTime ? new Date(row.OrderStartTime) : null),
    sortable: true,
    grow: 1,
    id: 'OrderStartTime',
    sortFunction: (rowA: any, rowB: any) => {
      const dateA = rowA.OrderStartTime ? new Date(rowA.OrderStartTime).getTime() : 0;
      const dateB = rowB.OrderStartTime ? new Date(rowB.OrderStartTime).getTime() : 0;
      return dateA - dateB;
    },
    cell: (row: any) => (
      <span data-tag="___react-data-table-allow-propagation___">
        {row.OrderStartTime ? format(new Date(row.OrderStartTime), 'MM/dd/yyyy hh:mm aaa') : ''}
      </span>
    ),
  },
  {
    name: `Complete Time (${new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]})`,
    selector: (row: any) => (row.OrderCompleteTime ? new Date(row.OrderCompleteTime) : null),
    sortable: true,
    grow: 1,
    id: 'OrderCompleteTime',
    sortFunction: (rowA: any, rowB: any) => {
      const dateA = rowA.OrderCompleteTime ? new Date(rowA.OrderCompleteTime).getTime() : 0;
      const dateB = rowB.OrderCompleteTime ? new Date(rowB.OrderCompleteTime).getTime() : 0;
      return dateA - dateB;
    },
    cell: (row: any) => (
      <span data-tag="___react-data-table-allow-propagation___">
        {row.OrderCompleteTime ? format(new Date(row.OrderCompleteTime), 'MM/dd/yyyy hh:mm aaa') : ''}
      </span>
    ),
  },
  {
    name: 'Seed Units',
    selector: 'SeedUnitsActual',
    sortable: true,
    grow: 0.6,
    cell: (row: any) => <span data-tag="___react-data-table-allow-propagation___">{row.SeedUnitsActual ? row.SeedUnitsActual.toFixed(2) : '0.00'}</span>,
  },
  {
    name: 'Duration (min)',
    selector: 'OrderDurationMinutes',
    sortable: true,
    grow: 0.6,
  },
  {
    name: 'Average Treat Rate (units/min)',
    selector: 'TreatRateUnitsPerMinute',
    sortable: true,
    grow: 0.8,
    cell: (row: any) => <span data-tag="___react-data-table-allow-propagation___">{row.TreatRateUnitsPerMinute ? row.TreatRateUnitsPerMinute.toFixed(2) : '-'}</span>,
  },
  {
    name: 'Fault Count',
    selector: 'FaultCount',
    sortable: true,
    grow: 0.6,
  },
  // {
  //   name: 'Alarm Messages',
  //   selector: 'AlarmMessages',
  //   sortable: true,
  //   grow: 1.5,
  //   wrap: true,
  // },
];

export const alarmHistoryColumns: IDataTableColumn<any>[] = [
  {
    name: 'Order Name',
    selector: 'pickup_order_name',
    sortable: true,
    grow: 0.6,
    cell: (row: any) => <span data-tag="___react-data-table-allow-propagation___">{row.pickup_order_name || '-'}</span>,
  },
  {
    name: 'Operator',
    selector: 'operator_name',
    sortable: true,
    grow: 0.6,
    cell: (row: any) => <span data-tag="___react-data-table-allow-propagation___">{row.operator_name || '-'}</span>,
  },
  {
    name: 'Alarm Message',
    selector: 'messages',
    sortable: true,
    grow: 2,
    wrap: true,
  },
  {
    name: `Log Time (${new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]})`,
    selector: (row: any) => (row.log_time ? new Date(row.log_time) : null),
    sortable: true,
    grow: 1,
    id: 'log_time',
    sortFunction: (rowA: any, rowB: any) => {
      const dateA = rowA.log_time ? new Date(rowA.log_time).getTime() : 0;
      const dateB = rowB.log_time ? new Date(rowB.log_time).getTime() : 0;
      return dateA - dateB;
    },
    cell: (row: any) => (
      <span data-tag="___react-data-table-allow-propagation___">
        {row.log_time ? format(new Date(row.log_time), 'MM/dd/yyyy hh:mm:ss aaa') : ''}
      </span>
    ),
  },
];
